
  import { defineComponent, ref, onMounted } from 'vue'
  import LoginBackground from '../components/Login/LoginBackground.vue'
  import LoginBox from '../components/Login/LoginBox.vue'
  
  export default defineComponent({
    name: 'Login',
    components: {
        LoginBackground,
        LoginBox
    },
    setup() {
        const screenWidth = window.screen.width
        let clientWidth = document.body.clientWidth
        const zoomRatio = ref(clientWidth / screenWidth)
        onMounted(() => {
            window.addEventListener('resize', () => {
                clientWidth = document.body.clientWidth
                zoomRatio.value = clientWidth / screenWidth
            })
        })
        const baseRatio = ref(screenWidth / 1920) // 以1920为基准
        return {
            baseRatio,
            zoomRatio
        }
    }
  })
  